<template>
  <div class="main">

      <div class="tutorial-content-wrapper">
        <h2>Congratulations! <TextToSpeechSimple :inputText="textOneSpeech"></TextToSpeechSimple></h2>
        <h4>You have completed the Offshore SMS Tutorial.</h4>
         <p>
          <router-link class="button is-primary" to="/">Back to Home Page</router-link>
        </p>

        <img class="hero-pic" src="../assets/boat-pic-1.jpg" alt="Fishing Boat">

        <!-- <button class="button is-primary" @click="sendData">Interact</button> -->
      </div>


  </div>
</template>


<script>

import TextToSpeechSimple from '../components/TextToSpeechSimple.vue';

export default {

  components: {
      TextToSpeechSimple,
  },

  props: [
      'interactionNeeded',
  ],

  computed: {

  },

  data() {
    return {
      textOneSpeech: 'Congratulations! You have completed the Offshore SMS Tutorial.',
    }
  },

  methods: {

    goBack: function() {
      console.log('Router',this.$router);
      this.$router.go(-1);
    },

    sendData: function() {
      let result = {
        hasInteracted: true,
      }
      this.$emit('sendData', result)
    },
    
  }
}
</script>



<style lang="scss" scoped>

  button {
    margin-top: 1rem;
  }
  h2 {
    margin-bottom: 2rem;
  }
  h4 {
    margin-bottom: 2rem;
  }
  img {
    max-width: 200px;
  }

</style>